import { render } from "./DEntryApproval.vue?vue&type=template&id=ce5ff060&scoped=true&lang=pug"
import script from "./DEntryApproval.vue?vue&type=script&lang=js"
export * from "./DEntryApproval.vue?vue&type=script&lang=js"

import "./DEntryApproval.vue?vue&type=style&index=0&id=ce5ff060&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5ff060"]])

export default __exports__